export default [
    'ToBeFilledIn',
    'ToBeCorrected',
    'ToBeApproved',
    'Approved',
    'Completed',
    'ProcessingNotApplicable'
]
export const dcStatusesEnums = Object.freeze(({'ToBeFilledIn': 0, 'ToBeCorrected': 1, 'ToBeApproved': 2, 'Approved': 3, 'Completed': 4, 'ProcessingNotApplicable': 5}));